import { CornerRadiusValues } from '../../../../cornerRadius/cornerRadius/index.js';
import { SpacingsValues } from '../../../../spacings/spacings/index.js';
import { TimingValues } from '../../../../timings/timings/index.js';
import { EasingValues } from '../../../../easing/easing/index.js';
import { TypographyValues } from '../../../../typography/typography/index.js';
import { DisabledValues } from '../../../../states/states/index.js';
import { objectToString } from '../../../../utils/objectToString/objectToString/index.js';

const primitiveStyles = `:root {
    ${objectToString(CornerRadiusValues)};
    ${objectToString(SpacingsValues)};
    ${objectToString(TimingValues)};
    ${objectToString(EasingValues)};
    ${objectToString(TypographyValues)};
    ${objectToString(DisabledValues)};
  }`;

export { primitiveStyles };
